import i18next from 'i18next';
import React from 'react';
import { StandardLocalWidget, any, async, fromJSX, nothing, wait } from "widgets-for-react";
import { RootLayout } from "../site/root/rootLayout";
import { changePaymentMethodUpdaters } from "./changePaymentMethod/changePaymentMethodState";
import { changePaymentMethodWidget } from "./changePaymentMethod/changePaymentMethodWidget";
import { editSubscriptionWidget } from "./editSubscription/editSubscriptionWidget";
import { newSubscriptionWidget } from "./newSubscription/newSubscriptionWidget";
import { payOpenInvoiceWidget } from "./payOpenInvoice/payOpenInvoiceWidget";
import { resumeSubscriptionWidget } from "./resumeSubscription/resumeSubscriptionWidget";
import { SubscriptionLayout } from "./subscriptionLayout";
import { SubscriptionState, subscriptionUpdaters } from "./subscriptionState";
import { subscriptionRoute } from './subscriptionUtils';
import { stripeUpgradeSubscriptionWidget } from './stripeUpgradeSubscription/stripeUpgradeSubscriptionWidget';
import { legacyAccountDetailsPageWidget } from './legacyAccountDetailsPageWidget/legacyAccountDetailsPageWidget';
import { accountDetailsPageWidget } from './accountDetailsPage/accountDetailsPageWidget';

export const subscriptionWidget: StandardLocalWidget<SubscriptionState> = currentState => {
  const isBlocked = currentState.userSubscriptions.kind == "loaded" && currentState.userSubscriptions.value.PaywallStatus == "Blocked";

  return (
    any([
      async(currentState.createPendingShoppingCart).map(subscriptionUpdaters.createPendingShoppingCart),
      async(currentState.resumeSubscription).map(subscriptionUpdaters.resumeSubscription),
      async(currentState.pauseSubscription).map(subscriptionUpdaters.pauseSubscription),
      async(currentState.subscribe).map(subscriptionUpdaters.subscribe),
      async(currentState.changeSubscription).map(subscriptionUpdaters.changeSubscription),
      async(currentState.changePassword).map(subscriptionUpdaters.changePassword),
      async(currentState.changePersonalInfo).map(subscriptionUpdaters.changePersonalInfo),
      async(currentState.changePaymentMethodInput.changePaymentMethod).map(_ => subscriptionUpdaters.changePaymentMethodInput(changePaymentMethodUpdaters.changePaymentMethod(_))),
      async(currentState.payOpenPayment).map(subscriptionUpdaters.payOpenPayment),
      async(currentState.lookupData).map(subscriptionUpdaters.lookupData),
      async(currentState.checkVATState).map(subscriptionUpdaters.checkVATState),
      async(currentState.startSubscriptionPortalSession).map(subscriptionUpdaters.onAsyncStartSubscriptionPortalSession),
      currentState.asyncsFailedReloadPage() ? wait(2500)(() => { alert(i18next.t(`subscription:AsyncErrorReloading`)); location.reload(); }).never() : nothing(),
      currentState.asyncsWorkingDisableInput()
        ? fromJSX(() => <RootLayout.Loader showText hasWrapper />)
        : isBlocked
          ? fromJSX(() => <SubscriptionLayout.BlockedAccount />)
          : currentState.kind == "overview"
            ? currentState.userSubscriptions.kind != "loaded"
              ? fromJSX(() => <RootLayout.Loader showText hasWrapper />)
              : currentState.userSubscriptions.value.IsStripeCustomer 
                ? accountDetailsPageWidget(currentState)
                : legacyAccountDetailsPageWidget(currentState)
            : currentState.kind == "subscription-success"
              || currentState.kind == "change-payment-method-success"
              || currentState.kind == "pay-open-invoice-success"
              ? fromJSX(setState =>
                <SubscriptionLayout.ThankYou
                  variant={currentState.kind === "subscription-success" ? 'subscription-success' : currentState.kind === "change-payment-method-success" ? 'change-payment-method-success' : 'pay-open-invoice-success'}
                  subscriptionState={currentState}
                  breadcrumbs={subscriptionRoute()}
                  setState={setState}
                />
              )
              : currentState.kind == "subscription-failure" || currentState.kind == "subscription-cancel" || currentState.kind == "change-payment-method-failure" || currentState.kind == "change-payment-method-cancel" || currentState.kind == "pay-open-invoice-failure" || currentState.kind == "pay-open-invoice-cancel"
                ? fromJSX(() =>
                  <SubscriptionLayout.FailureOrCancel
                    variant={currentState.kind == "subscription-failure"
                      ? 'subscription-failure'
                      : currentState.kind == 'subscription-cancel'
                        ? 'subscription-cancel'
                        : currentState.kind == "change-payment-method-failure"
                          ? 'change-payment-method-failure'
                          : currentState.kind == 'change-payment-method-cancel'
                            ? 'change-payment-method-cancel'
                            : currentState.kind == "pay-open-invoice-failure"
                              ? 'pay-open-invoice-failure'
                              : 'pay-open-invoice-cancel'
                    }
                  />
                )
                : currentState.kind == "new subscription flow" ?
                  newSubscriptionWidget(currentState)
                  : currentState.kind == "stripe subscription flow" ?
                    stripeUpgradeSubscriptionWidget(currentState)
                    : currentState.kind == "edit subscription flow" ?
                      editSubscriptionWidget(currentState)
                      : currentState.kind == "resume subscription flow" ?
                        resumeSubscriptionWidget(currentState)
                        : currentState.kind == "change payment method flow" ?
                          changePaymentMethodWidget(currentState)
                          : currentState.kind == "pay open payment flow" ?
                            payOpenInvoiceWidget(currentState)
                            :
                            nothing()
    ])

  )
}